import store from '../../../store/store';
import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { CENTRAL_API_BASE_URL } from '../../constants/central-api';
import { submitLogToBugsnag } from '../log';

export default async function refresh_mcp_accounts_api_call(
  connectionId: number
) {
  try {
    const accessToken = store.getState().auth.authorization.accessToken;
    const isWhiteLabel = store.getState().UI?.isWhiteLabel;
    let sellerToken: string;
    if (isWhiteLabel) {
      sellerToken = accessToken?.currentWhiteLabelSellerToken;
    } else {
      sellerToken = accessToken?.sellerToken;
    }

    const requestInfo: RequestInfo = {
      url: `${CENTRAL_API_BASE_URL}tara/mcp/accounts/${connectionId}`,
      method: 'POST',
      body: '',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        Authorization: accessToken.type + ' ' + sellerToken,
      },
    };

    const actionType = 'REFRESH_MCP_ACCOUNTS';
    const customMsg = 'Accounts refreshed successfully.';

    const res: any = await asyncHandler(
      requestInfo,
      actionType,
      customMsg,
      false
    );

    const response = res?.data;
    if (!response.success) {
      return false;
    }
    if (res.actionType === actionType && response.success === true) {
      return response?.data;
    }
  } catch (exception) {
    console.log('Error refreshing MCP accounts');
    submitLogToBugsnag('error', `Error refreshing MCP accounts: ${exception}`);
    return false;
  }
}
